import script from "./insert-failed.vue?vue&type=script&lang=js"
export * from "./insert-failed.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__